import {HookClass, Hook, BaseHook, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {from, Observable, Observer} from 'rxjs';
import {createReadStream} from 'node:fs';
import {concatMap, map, toArray} from 'rxjs/operators';
import {ArtfactKind} from "@mrp-brasil/nick-data-commons";
import Jimp from 'jimp';

@HookClass('image')
export class ImageHook extends BaseHook {

    @Hook('5442f5b4-3964-48e5-95c0-1c17963fb336')
    public resize(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const file = inputArtifact.object.buffer;

        const cachedJpegDecoder: any = Jimp.decoders['image/jpeg'];
        Jimp.decoders['image/jpeg'] = (data) => {
            const userOpts = {maxMemoryUsageInMB: 1024, maxResolutionInMP: 200};
            return cachedJpegDecoder(data, userOpts);
        };

        return from(inputArtifact.object.config.resize)
            .pipe(concatMap((size: any) => {
                const width = size[0];
                const height = size[1];
                return from(Jimp.read(file.path))
                    .pipe(concatMap((image: Jimp) => {
                        return new Observable<any>((observer: Observer<any>) => {
                            image.resize(width, height).write(`${file.path}@${width}x${height}`, (param: any) => {
                                observer.next(param);
                                observer.complete()
                            });
                        })
                            .pipe(map(()=>{
                                const fileStream = createReadStream(`${file.path}@${width}x${height}`);
                                return {
                                    id: `${inputArtifact.object.id}@${width}x${height}`,
                                    buffer: fileStream,
                                    contentType: inputArtifact.object.contentType,
                                    dimension: `${width}x${height}`
                                }
                            }))
                    }))
            }), toArray())
            .pipe(map((images: []) => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = ArtfactKind.ANY;
                outputArtifact.object = images.map((image: any) => image && image.toJson ? image.toJson : image);
                return outputArtifact;
            }));
    }

    @Hook('7065eb47-1abf-4078-b911-04a6609444f4')
    public resizeImage(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const { object } = inputArtifact;
        const fileBuffer = object.buffer;
        const filePath = object.path;
        const contentType = object.contentType;
        const resizeConfigs = object.config.resize;

        // Ajusta limites de decodificação JPEG (protege contra imagens muito grandes)
        const cachedJpegDecoder: any = Jimp.decoders['image/jpeg'];
        Jimp.decoders['image/jpeg'] = (data) => {
            const userOpts = { maxMemoryUsageInMB: 1024, maxResolutionInMP: 200 };
            return cachedJpegDecoder(data, userOpts);
        };

        // Função auxiliar para abrir a imagem, seja buffer ou path
        const readImage = (): Promise<Jimp> => {
            if (fileBuffer && Buffer.isBuffer(fileBuffer)) {
                return Jimp.read(fileBuffer);
            } else if (filePath && typeof filePath === 'string') {
                return Jimp.read(filePath);
            } else {
                return Promise.reject(
                    new Error('Input artifact must contain either a valid buffer or path.')
                );
            }
        };

        return from(resizeConfigs).pipe(
            concatMap((size: [number, number]) => {
                const [width, height] = size;

                return from(readImage()).pipe(
                    concatMap((image: Jimp) =>
                        from(
                            new Promise((resolve, reject) => {
                                const mimeType = contentType || image.getMIME(); // preserva o tipo original

                                image
                                    .resize(width, height)
                                    .getBuffer(mimeType, (err, resizedBuffer) => {
                                        if (err) return reject(err);

                                        resolve({
                                            buffer: resizedBuffer,
                                            contentType: mimeType,
                                            dimension: `${width}x${height}`
                                        });
                                    });
                            })
                        )
                    )
                );
            }),
            toArray(),
            map((images: any[]) => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = ArtfactKind.ANY;
                outputArtifact.object = images.map((image: any) =>
                    image && image.toJson ? image.toJson() : image
                );
                return outputArtifact;
            })
        );
    }
}
